module.exports = __webpack_public_path__ + "static/undraw_personal_settings_kihd-80f9265b611a51c226182cbbc073296a.svg";